import { Pipe, PipeTransform } from '@angular/core';

import { IUser } from 'user/user';

@Pipe({
	name: 'usersName',
})
export class UsersNamePipe implements PipeTransform {
	constructor() {}

	transform(value: IUser[] | null, excludeUserId?: string): string {
		return ((value as IUser[]) || [])
			.filter((u) => !excludeUserId || !excludeUserId.includes(u.id))
			.map((u) => u.name)
			.join(', ');
	}
}
